/**
 * Stuff that needs to happen on every page
 */
$(function() {
    $('html').addClass('js').removeClass('no-js');
});
